<template>
  <div class="billet-box-component">
    <div class="box">
      <div class="pt-5 px-6 px-3-mobile">
        <div class="columns">
          <div class="column is-12">
            <h1 class="is-size-2 is-size-3-mobile has-text-centered has-text-weight-bold">
              Número do Boleto
            </h1>
          </div>
        </div>
        <div class="columns is-fullwidth is-mobile">
          <div class="column is-9-desktop is-8-mobile">
            <p class="is-size-2 is-size-5-mobile has-text-centered has-text-black is-truncate-text">
              {{ billetCode }}
            </p>
          </div>
          <div
            class="column is-3-desktop is-4-mobile is-fullwidth is-clickable"
            @click.prevent="copyBilletCode()"
          >
            <div class="columns is-mobile">
              <div class="column is-12 is-flex is-justify-content-center has-text-centered is-align-content-center pb-0">
                <font-awesome-icon
                  icon="fa-regular fa-copy"
                  size="2x"
                  class="copy-icon"
                />
              </div>
            </div>
            <div class="columns is-mobile">
              <div class="column is-12 has-text-centered pt-0 has-text-grey-secondary has-text-weight-bold">
                <span class="copy-text">Copiar</span>
              </div>
            </div>
          </div>
        </div>
        <div class="columns mt-2 pt-2 is-fullwidth">
          <div
            class="column is-12"
          >
            <a target="_blank" :href="this.billetUrl" class="download-link">
              <div class="columns">
                <div class="column is-12 is-flex is-justify-content-center has-text-centered is-align-content-center pb-0">
                  <font-awesome-icon
                      icon="fa-solid fa-download"
                      size="4x"
                      class="download-icon"
                  />
                </div>
              </div>
              <div class="columns mt-2">
                <div class="column is-12 has-text-centered pt-0 has-text-grey-secondary has-text-weight-bold">
                  <span class="download-text">Baixar boleto</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios"

export default {

  name: 'billet-box',

  props: {
    billetCode: {
      required: true,
      type: String
    },
    billetUrl: {
      required: true,
      type: String
    }
  },

  methods: {
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
      } catch (err) { return }

      document.body.removeChild(textArea);
    },
    copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text);
        return;
      }

      navigator.clipboard.writeText(text)
    },
    copyBilletCode() {
      this.copyTextToClipboard(this.billetCode)
    },
    downloadBillet() {
      axios.get(this.billetUrl, {
        responseType: 'blob'
      }).then(res => {
        const blob = new Blob(
            [res.data],
            {
              type: `application/pdf;charset=utf-8;`
            }
        )

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'boleto.pdf';
        link.click()
        window.URL.revokeObjectURL(link.href)
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.billet-box-component {
  &.is-fullheight {
    height: 100%;
  }

  .box {
    background-color: white;
    box-shadow: none;
    z-index: 1030;
    margin-top: 0 !important;
    padding-top: 0 !important;

    &.is-full {
      height: 100vh;
      width: 100vw;
    }

    hr {
      border: none;
      height: 3px;
      color: #dae6ec;
      background-color: #dae6ec;
    }
  }
  
  .is-clickable {
    cursor: pointer;
    transition: all 0.2s ease;
    
    &:hover {
      opacity: 0.8;
    }
    
    &:active {
      transform: scale(0.98);
    }
  }
  
  .download-link {
    display: block;
    transition: all 0.2s ease;
    
    &:hover {
      opacity: 0.8;
    }
  }
  
  .is-truncate-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media screen and (max-width: 768px) {
  .billet-box-component {
    .box {
      margin-bottom: 2rem;
    }
    
    .is-size-3-mobile {
      font-size: 1.5rem !important;
    }
    
    .is-size-5-mobile {
      font-size: 0.9rem !important;
      padding: 0.5rem 0;
    }
    
    .px-3-mobile {
      padding-left: 0.75rem !important;
      padding-right: 0.75rem !important;
    }
    
    .copy-icon {
      font-size: 1.2rem !important;
    }
    
    .copy-text {
      font-size: 0.8rem;
    }
    
    .download-icon {
      font-size: 2.5rem !important;
    }
    
    .download-text {
      font-size: 0.9rem;
    }
  }
}

@media screen and (max-width: 400px) {
  .billet-box-component {
    .is-size-5-mobile {
      font-size: 0.75rem !important;
    }
    
    .copy-icon {
      font-size: 1rem !important;
    }
    
    .copy-text {
      font-size: 0.7rem;
    }
    
    .download-icon {
      font-size: 2rem !important;
    }
    
    .download-text {
      font-size: 0.8rem;
    }
  }
}
</style>
